(function () {
    'use strict';

    angular
        .module('uwAgenda.users')
        .directive('usernameValidation', UsernameValidationFn);

    /* username validation directive */
    /* if rules change, also update server-side validation */
    UsernameValidationFn.$inject = [];

    function UsernameValidationFn() {

        var directive = {
            link: link,
            require: 'ngModel',
            restrict: 'A'
        };
        return directive;

        function link(scope, element, attrs, mCtrl) {
            function validate(value) {
                if (value == null || value.length < 3) {
                    mCtrl.$setValidity('usernameValid', false);
                } else {
                    mCtrl.$setValidity('usernameValid', true);
                }
                return value;
            }
            mCtrl.$parsers.push(validate);
        }
    }
})();